<template>
  <div class="text-center">
    <div class="header px-2 pb-1">
      <img
        alt="success"
        width="66px"
        :src="require('@/assets/images/pages/payment/ic-top-up-inprogress.png')"
      >
      <h3 class="my-1">
        {{ $t('payment.wiseTransfer.titleTopupInprocess') }}
      </h3>
      <p>{{ $t('payment.wiseTransfer.subTitleTopupInprocess') }}</p>
    </div>
    <div class="summary p-2">
      <h4
        id="title-summary-lianlian-card"
        data-testid="title-summary-lianlian-card"
        class="text-left mb-2"
      >
        {{ $t('addFundPage.creditCardPayment.textSummary') }}
      </h4>
      <div class="d-flex align-items-center justify-content-between mb-1 flex-wrap">
        <div
          id="summary-lianlian-card-title-client"
          data-testid="summary-lianlian-card-title-client"
          class="font-14 text-placeholder"
        >
          {{ $t('addFundPage.creditCardPayment.textClient') }}
        </div>
        <strong
          id="summary-lianlian-card-client-name"
          data-testid="summary-lianlian-card-client-name"
        >
          {{ fullName }}
        </strong>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-1">
        <div
          id="summary-lianlian-card-title-amount"
          data-testid="summary-lianlian-card-title-amount"
          class="font-14 text-placeholder"
        >
          {{ $t('balance.textAmount') }}
        </div>
        <strong
          id="summary-lianlian-card-current-amount"
          data-testid="summary-lianlian-card-current-amount"
        >
          {{ localStringFormat(amount) }} USD
        </strong>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-1">
        <div
          id="summary-lianlian-card-title-method"
          data-testid="summary-lianlian-card-title-method"
          class="font-14 text-placeholder"
        >
          {{ $t('addFundPage.creditCardPayment.textPaymentMethod') }}
        </div>
        <div
          id="summary-lianlian-card-content-method"
          data-testid="summary-lianlian-card-content-method"
        >
          <img
            id="summary-lianlian-icon-method"
            data-testid="summary-lianlian-icon-method"
            :src="require('@/assets/images/pages/payment/ic-lianlian.svg')"
            width="18px"
            alt="LianLian"
            class="mr-0"
          >
          <strong
            id="summary-lianlian-current-method"
            data-testid="summary-lianlian-current-method"
          >LianLian</strong>
        </div>
      </div>

      <div
        v-if="percentFee || (detailInfo && detailInfo.serviceCharge)"
        class="d-flex align-items-center justify-content-between mb-1"
      >
        <div
          id="summary-lianlian-card-title-service-charge"
          data-testid="summary-lianlian-card-title-service-charge"
          class="font-14 text-placeholder"
        >
          {{ $t('payment.balanceTransactionsTable.textServiceCharge') }}
        </div>
        <strong
          id="summary-lianlian-card-current-service-charge"
          data-testid="summary-lianlian-card-current-service-charge"
          class="theme-text-primary"
        >{{ serviceCharge }} USD</strong>
      </div>

      <div
        v-if="methodFee || (detailInfo && detailInfo.paymentGateCharge)"
        class="d-flex align-items-center justify-content-between mb-1"
      >
        <div
          id="title-method-fee-lianlian"
          data-testid="title-method-fee-lianlian"
          class="font-14 text-placeholder"
        >
          {{ $t('payment.paypal.textPaymentFee', {payment:"LianLian"}) }}
          <small
            id="percent-po-fee"
            data-testid="percent-po-fee"
            class="font-small-1"
            style="margin-right: 6px"
          >
            {{ `(${methodFeeTxt})` }}
          </small>
        </div>
        <div>
          <div
            class="d-flex align-items-center"
          >
            <strong
              id="summary-current-po-fee"
              data-testid="summary-current-po-fee"
              class="text-primary"
            >{{ LianLianFee }} USD</strong>
          </div>
        </div>
      </div>

      <div
        v-if="taxRate || (detailInfo && detailInfo.taxCharge)"
        class="d-flex align-items-center justify-content-between mb-1"
      >
        <div
          id="title-tax-fee-lianlian"
          data-testid="title-tax-fee-lianlian"
          class="font-14 text-placeholder"
        >
          {{ $t('payment.balanceTransactionsTable.textTax') }}
          <small
            id="percent-tax-po-fee"
            data-testid="percent-tax-po-fee"
            class="font-small-1"
            style="margin-right: 6px"
          >
            {{ `(${percentTaxTxt})` }}
          </small>
        </div>
        <div>
          <div
            id="summary-current-tax-po-fee"
            data-testid="summary-current-tax-po-fee"
            class="d-flex align-items-center"
          >
            <strong
              id="current-tax-po-fee"
              data-testid="current-tax-po-fee"
              class="text-primary"
            >{{ tax }} USD</strong>
          </div>
        </div>
      </div>

      <div
        v-if="tipAmount > 0"
        class="d-flex align-items-center justify-content-between mb-1"
      >
        <div
          id="summary-usdt-title-tip-amount"
          data-testid="summary-usdt-title-tip-amount"
          class="font-14 text-placeholder"
        >
          Tip
        </div>
        <strong
          id="summary-usdt-current-tip-amount"
          data-testid="summary-usdt-current-tip-amount"
          class="text-primary"
        >{{ tipAmountTxt }} USD</strong>
      </div>

      <hr class="hr-custom">

      <div class="d-flex align-items-center justify-content-between">
        <div
          id="summary-lianlian-card-title-total-amount"
          data-testid="summary-lianlian-card-title-total-amount"
          class="font-14 text-placeholder text-left"
        >
          {{ $t('addFundPage.creditCardPayment.textTotalAmount') }} = {{ $t('balance.textAmount') }}
          {{ percentFee || (detailInfo && detailInfo.serviceCharge) ? ` + ${$t('payment.balanceTransactionsTable.textServiceCharge')}` : '' }}
          {{ taxRate || (detailInfo && detailInfo.taxCharge) ? ` + ${$t('payment.balanceTransactionsTable.textTax')}` : '' }}
          {{ methodFee || (detailInfo && detailInfo.paymentGateCharge) ? ` + ${$t('payment.paypal.textPaymentFee', { payment: 'Payoneer' })}` : '' }}
          {{ tipAmount > 0 ? ' + Tip' : '' }}
        </div>
      </div>
      <h3
        id="summary-lianLian-card-current-total-amount"
        data-testid="summary-lianLian-card-current-total-amount"
        class="mt-2 text-left"
      >
        {{ totalAmount }} USD
      </h3>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import _get from 'lodash/get'
import { bus } from '@/plugins/bus'

import numberFormatMixin from '@/mixins/numberFormatMixin'
import paymentMixin from '@/mixins/paymentMixin'
import generalConfigsMixin from '@/mixins/generalConfigsMixin'
import stepGuideMixin from '@/mixins/stepGuideMixin'
import { PAYMENT_METHOD } from '@/constants'

const { mapGetters } = createNamespacedHelpers('payment')
const { mapGetters: mapGettersAuth } = createNamespacedHelpers('auth')

export default {
  mixins: [numberFormatMixin, generalConfigsMixin, paymentMixin, stepGuideMixin],
  props: {
    detailInfo: {
      type: Object,
      required: false,
      default: () => {
      },
    },
    amount: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      historyTicket: {},
    }
  },

  computed: {
    ...mapGetters(['listCard', 'loading', 'listTicket']),
    ...mapGettersAuth(['user']),

    isShowBtnBackToDemoView() {
      return this.hasStepGuide && this.user?.data?.balance > 0
    },

    fullName() {
      const fullName = _get(this.user, ['data', 'fullName'], '')
      const email = _get(this.user, ['data', 'email'], '')
      return fullName || email
    },

    percentFee() {
      return this.user?.data?.plans?.transferFee?.lianLianTicket || 0
    },

    serviceCharge() {
      if (!this.detailInfo) {
        return this.amountFormat(this.percentFee * this.amount)
          .toLocaleString('en-US')
      }

      if (this.detailInfo?.serviceCharge) {
        return this.detailInfo?.serviceCharge
      }

      return 0
    },

    methodFee() {
      return this.generalConfigs?.paymentGateFee?.lianLianTicketGate || 0
    },

    methodFeeTxt() {
      return `${(this.methodFee * 100).toFixed(2)}%`
    },

    LianLianFee() {
      if (!this.detailInfo) {
        return this.amountFormat(this.methodFee * this.amount)
          .toLocaleString('en-US')
      }
      if (this.detailInfo?.paymentGateCharge) {
        return this.detailInfo?.paymentGateCharge
      }
      return 0
    },

    percentTaxTxt() {
      return `${(this.taxRate * 100).toFixed(2)}%`
    },

    tax() {
      if (!this.detailInfo) {
        return this.amountFormat(this.taxRate * this.amount)
          .toLocaleString('en-US')
      }

      if (this.detailInfo?.taxCharge) {
        return this.detailInfo?.taxCharge
      }

      return 0
    },

    tipAmount() {
      return this.historyTicket?.details?.tipAMAmount || null
    },

    tipAmountTxt() {
      return this.amountFormat(this.tipAmount)
        .toLocaleString('en-US')
    },

    totalAmount() {
      if (!this.detailInfo) {
        const fee = this.amountFormat(this.percentFee * this.amount)
        const tax = this.amountFormat(this.taxRate * this.amount)
        const methodFee = this.amountFormat(this.methodFee * this.amount)
        return (this.amount + fee + tax + methodFee + this.tipAmount).toLocaleString('en-US')
      }

      const {
        serviceCharge,
        taxCharge,
        paymentGateCharge,
      } = this.detailInfo

      return (this.amount + serviceCharge + taxCharge + paymentGateCharge + this.tipAmount).toLocaleString('en-US')
    },
  },

  watch: {
    listTicket: {
      handler(ticket) {
        if (ticket.paging.total > 0) {
          this.historyTicket = ticket?.content?.find(transaction => transaction.details.paymentMethod === PAYMENT_METHOD.LIANLIAN_TICKET)
        }
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    bus.$on('set-invoice-data', data => {
      this.amount = data.amount
    })
  },
}
</script>
<style lang="scss" scoped>
.hr-custom {
  border-top: 1px solid #EEEEEE;
}

.summary {
  border-radius: 24px;
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
}
</style>
